<script>
import FormBase from '@/components/FormBase';

export default {
  name: "FormUsuario",

  extends: FormBase,
  computed: {
    puedeEditar () {
      return true;
    },
    puedeEliminar () {
      return true;
    },
    createUrl() {
      return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`;
    },
    updateUrl() {
      return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`;
    },
  },
}
</script>

<style scoped>

</style>
